import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { RelatorioFinanceiroApiService } from './services/relatorio-financeiro-api.service';
import { TipoLancamento } from '@models/tipo-lancamento';
import { ContaCaixa } from '@models/conta-caixa';
import { RelatorioCaixaListItem } from '../configurar-relatorio-caixa/models/relatorio-caixa-list-item';
import { CategoriaRelatorioListItem } from './models/categoria-relatorio-list-item';

export interface RelatorioFinanceiroResolverData {
  contasCaixa: ContaCaixa[];
  tiposLancamento: TipoLancamento[];
  relatoriosCaixa: RelatorioCaixaListItem[];
  categoriasCaixa: CategoriaRelatorioListItem[];
}

@Injectable()
export class RelatorioFinanceiroResolver implements Resolve<RelatorioFinanceiroResolverData> {

  constructor(private relatorioFinanceiroApiService: RelatorioFinanceiroApiService) { }

  resolve(): Observable<RelatorioFinanceiroResolverData> {
    return zip(
      this.relatorioFinanceiroApiService.getContasCaixa(),
      this.relatorioFinanceiroApiService.getTiposLancamento(),
      this.relatorioFinanceiroApiService.getRelatoriosCaixa(),
      this.relatorioFinanceiroApiService.getTodasCategorias(),
    ).pipe(
      map(([contasCaixa, tiposLancamento, relatoriosCaixa, categoriasCaixa]) =>
        ({ contasCaixa, tiposLancamento, relatoriosCaixa, categoriasCaixa }))
    );
  }
}
